import * as Buttons from "./Buttons";

export const NumbersPadUI =
    [Buttons.SEVEN,
        Buttons.EIGHT,
        Buttons.NINE,
        Buttons.FOUR,
        Buttons.FIVE,
        Buttons.SIX,
        Buttons.ONE,
        Buttons.TWO,
        Buttons.THREE,
        Buttons.DOUBLE_ZERO,
        Buttons.ZERO,
        Buttons.DOT,
    ]